import React, { useEffect, useRef } from "react";

// ── Status pill ──────────────────────────────────────────
const STATUS = {
  Received:  { cls: "pill-blue",   icon: "◉", label: "Received"   },
  Shipped:   { cls: "pill-amber",  icon: "◎", label: "In Transit" },
  Delivered: { cls: "pill-green",  icon: "✓", label: "Delivered"  },
};
export function StatusPill({ status }) {
  const cfg = STATUS[status] || STATUS.Received;
  return <span className={`status-pill ${cfg.cls}`}>{cfg.icon} {cfg.label}</span>;
}

// ── Modal ────────────────────────────────────────────────
export function Modal({ id, title, onClose, children, maxWidth = 520 }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth }}>
        <div className="modal-head">
          <span className="modal-title">{title}</span>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

// ── Spinner ──────────────────────────────────────────────
export function Spinner({ msg = "Loading..." }) {
  return (
    <div className="spinner-wrap">
      <div className="spinner" />
      {msg && <p className="spinner-msg">{msg}</p>}
    </div>
  );
}

// ── Empty state ──────────────────────────────────────────
export function EmptyState({ msg = "No packages found" }) {
  return (
    <div className="empty-state">
      <div className="empty-icon">📦</div>
      <p className="empty-txt">{msg}</p>
    </div>
  );
}

// ── Package thumbnail ────────────────────────────────────
export function PkgThumb({ photoURL, size = 88 }) {
  return (
    <div className="pkg-img" style={{ width: size, height: size }}>
      {photoURL
        ? <img src={photoURL} alt="Package" loading="lazy" />
        : <span style={{ fontSize: 28 }}>📦</span>}
    </div>
  );
}

// ── Stat card ────────────────────────────────────────────
export function StatCard({ label, value, color }) {
  return (
    <div className="stat-card">
      <div className="stat-label">{label}</div>
      <div className="stat-num" style={color ? { color } : {}}>{value ?? "—"}</div>
    </div>
  );
}

// ── Toast (imperative, global) ───────────────────────────
export function toast(msg, type = "success") {
  const el = document.createElement("div");
  el.className = `toast toast-${type}`;
  el.textContent = msg;
  document.body.appendChild(el);
  setTimeout(() => el.classList.add("show"), 10);
  setTimeout(() => { el.classList.remove("show"); setTimeout(() => el.remove(), 300); }, 3200);
}

// ── Photo upload input ───────────────────────────────────
export function PhotoUpload({ onChange, preview }) {
  return (
    <div className="photo-upload">
      <input type="file" accept="image/*" onChange={e => onChange(e.target.files[0] || null)} />
      {preview
        ? <img src={preview} alt="Preview" className="photo-preview" />
        : <div>
            <div className="photo-upload-icon">📷</div>
            <div className="photo-upload-text">Click to upload a photo of the package</div>
          </div>}
    </div>
  );
}

// ── Format date ──────────────────────────────────────────
export function formatDate(val) {
  if (!val) return "—";
  const d = val?.toDate ? val.toDate() : new Date(val + "T12:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}
